export default "<app-student-list [students]=\"students\" [showDiagnosticBtn]=\"true\"></app-student-list>\r\n"